import { useState } from "react";
import { RadioGroup } from "../../ui/RadioGroup";
import { SubHead } from "../../ui/SubHead";
import { Select } from "../../ui/Select";
import { yesNoOption } from "../../options/options";
import { Input } from "../../ui/Input";
import { Textarea } from "../../ui/Textarea";
import ConfirmActionModal from "../../ui/ConfirmActionModal";

import { userSession } from "../../../observers/userObserver";
import ConfirmationModal from "../../ui/ConfirmationModal";

export const RiskAssesForm = ({
    formData,
    handleChange,
    isReadOnly,
    isReport,
    handleChangewithPopUp,
    handleSubmit,
    handleSearch,
    handleUboSearch
}) => {
    const userEmail = userSession.getUserEmail();
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [showAdverseSearchModal, setShowAdverseSearchModal] = useState(false);
    const [showUboSearchModal, setShowUboSearchModal] = useState(false);
    const [uboConfirmationModal, setUboConfirmationModal] = useState(false);
    const [adverseSearchInfo, setAdverseSearchInfo] = useState("");
    const [uboSearchInfo, setUboSearchInfo] = useState("");
    return (
        <div className="transaction-form form_information">
            <h2>Risk Assessment</h2>
            <form onSubmit={handleSubmit}>

                <SubHead text=' "PEP" (Politicially Exposed Person) & Sanctions Risk' isReport={isReport} />
                <RadioGroup
                    label={"Have you undertaken PEP & Sanctions screenings on the entity and the +25% ultimate beneficial owners?"}
                    name="pep"
                    value={formData.pep}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Is the client/counterparty or beneficial owner a PEP (Politically Exposed Person), a family member of a PEP or  a known close associate of a PEP?"
                    name="pepOwner"
                    value={formData.pepOwner}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Is the client/counterparty or beneficial owner a “Sanctioned Person”? 						"
                    name="sanctionedPerson"
                    value={formData.sanctionedPerson}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <SubHead text="Client / Counterparty Risk" isReport={isReport} />
                <RadioGroup
                    label="Do you understand this client/counterparty's overall business? 						"
                    name="understandClientBussiness"
                    value={formData.understandClientBussiness}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <Textarea
                    label="Please explain"
                    name="understandClientBussinessExplanation"
                    value={formData.understandClientBussinessExplanation}
                    onChange={handleChange}
                    disabled={isReadOnly}
                    required={true}
                    isReport={isReport}
                    placeholder="Please provide an explanation for your answer"
                />
                <RadioGroup
                    label="Do you understand why they are entering this particular transaction? 						 						"
                    name="particularTransaction"
                    value={formData.particularTransaction}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <Textarea
                    label="Please explain"
                    name="particularTransactionExplanation"
                    value={formData.particularTransactionExplanation}
                    onChange={handleChange}
                    disabled={isReadOnly}
                    required={true}
                    isReport={isReport}
                    placeholder="Please provide an explanation for your answer"
                />
                <SubHead text="Proliferation, Terrorist Financing & Financial Crime " isReport={isReport} />
                <RadioGroup
                    label="Have you found any evidence of legal and/or regulatory sanction or enforcement in relation to proliferation and/or terrorist financing?"
                    name="terroristFinancing"
                    value={formData.terroristFinancing}
                    disabled={isReadOnly}
                    required={true}
                    onChange={handleChangewithPopUp}
                    datalabel="Have you found any evidence of regulatory sanction or enforcement in relation to terrorist financing?"
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Have you found any evidence of legal and/or regulatory sanction or enforcement in relation to financial crime?"
                    name="financialCrime"
                    value={formData.financialCrime}
                    disabled={isReadOnly}
                    required={true}
                    datalabel="Have you found any evidence of regulatory sanction or enforcement in relation to financial crime?"
                    onChange={handleChangewithPopUp}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <SubHead text="Sector Risk" isReport={isReport} />
                <Select
                    label="Does your client/counterparty belong to any of the following sectors?"
                    name="sectorFromDropdown"
                    value={formData.sectorFromDropdown}
                    onChange={handleChange}
                    required={true}
                    datalabel="Does your client/counterparty belong to any of the following sectors?"
                    disabled={isReadOnly}
                    isReport={isReport}
                    options={[
                        { value: "Oil and Gas", display_value: "Oil and Gas" },
                        { value: "Arms and Ammunition", display_value: "Arms and Ammunition" },
                        { value: "Precious Metals, Stones and Commodoties", display_value: "Precious Metals, Stones and Commodoties" },
                        { value: "Tobacco, Narcotics and Alcohol", display_value: "Tobacco, Narcotics and Alcohol" },
                        { value: "Cultural Artefacts", display_value: "Cultural Artefacts" },
                        { value: "Ivory and Protected Species Trade", display_value: "Ivory and Protected Species Trade" },
                        { value: "Rare Scientific Items", display_value: "Rare Scientific Items" },
                        { value: "Cryptocurrencies and Digital Assets", display_value: "Cryptocurrencies and Digital Assets" },
                        { value: "Art and Antiques", display_value: "Art and Antiques" },
                        { value: "Gambling and Casinos", display_value: "Gambling and Casinos" },
                        { value: "Luxury Goods", display_value: "Luxury Goods" },
                        { value: "None of the above", display_value: "None of the above" }
                    ]}
                />
                <RadioGroup
                    label="Is the client involved in a business which is cash intensive?"
                    name="cashIntensive"
                    value={formData.cashIntensive}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />

                {formData.cashIntensive === "Yes" && (
                    <>
                        <Select
                            label="Please select the cash intensive business sector"
                            name="cashIntensiveBusinessName"
                            value={formData.cashIntensiveBusinessName}
                            onChange={handleChange}
                            datalabel="Please select the cash intensive business sector"
                            disabled={isReadOnly}
                            isReport={isReport}
                            required={true}
                            options={[
                                { value: "Hospitality", display_value: "Hospitality" },
                                { value: "CarWash", display_value: "Car Wash" },
                                { value: "Laundrette", display_value: "Laundrette" },
                                { value: "Beauty Salons & Barber Shops", display_value: "Beauty Salons & Barber Shops" },
                                { value: "Taxi and Transportation Services:", display_value: "Taxi and Transportation Services:" },
                                { value: "Gaming and Betting Establishments", display_value: "Gaming and Betting Establishments" },
                                { value: "Convenience Stores and Corner Shops:", display_value: "Convenience Stores and Corner Shops:" },
                                { value: "Vending Machine Operators", display_value: "Vending Machine Operators" },
                                { value: "Parking Facilities", display_value: "Parking Facilities" },
                                { value: "Seasonal Retailers", display_value: "Seasonal Retailers" },
                                { value: "Market Vendors", display_value: "Market Vendors" },
                                { value: "Transport and Shipping", display_value: "Transport and Shipping" },
                                { value: "Souvenir Shops", display_value: "Souvenir Shops" },
                                { value: "Other", display_value: "Other" }
                            ]}
                        />

                        {formData.cashIntensiveBusinessName === "Other" && (
                            <Input
                                label="Please specify other cash intensive business sector"
                                isReport={isReport}
                                type="text"
                                name="otherCashIntensiveBusinessName"
                                value={formData.otherCashIntensiveBusinessName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Please specify other cash intensive business sector"
                                disabled={isReadOnly}
                                style={{ marginTop: "10px", width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                            />
                        )}
                    </>
                )}


                <SubHead text="Behaviour Risk" isReport={isReport} />
                <RadioGroup
                    label="Has the client/counterparty been evasive or unusually reluctant to provide you with information and/or documents?"
                    name="pepEvasive"
                    value={formData.pepEvasive}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Has the client/counterparty insisted that the transaction be completed with undue speed?"
                    name="transactionCompletedWithUndueSpeed"
                    value={formData.transactionCompletedWithUndueSpeed}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <SubHead text="Reputational Risk" isReport={isReport} />

                {/* <button  onClick={() => setShowAdverseSearchModal(true)} style={{marginTop: "10px",padding: "8px", border: "none", background: "rgb(7, 177, 176)",color: "white",borderRadius: "4px", cursor: "pointer", marginRight: "10px"}}>
                    Perform Adverse Media Search
                </button> */}

                <button type="button" onClick={() => setShowUboSearchModal(true)} style={{marginTop: "10px",padding: "8px", border: "none", background: "rgb(7, 177, 176)",color: "white",borderRadius: "4px", cursor: "pointer"}}>
                   Perform Adverse Media Search
                </button>

                <RadioGroup
                    label="Have you conducted an adverse media search on the client/counterparty and its beneficial owners?"
                    name="adverseSearch"
                    value={formData.adverseSearch}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Have your media searches revealed any adverse publicity in relation to the client/counterparty?"
                    name="adversePublicity"
                    value={formData.adversePublicity}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <RadioGroup
                    label="Have you been made aware of any other adverse information in relation to this client/counterparty or its UBOs?"
                    name="adverseInformation"
                    value={formData.adverseInformation}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    options={yesNoOption}
                    isReport={isReport}
                    required={true}
                />
                <RadioGroup
                    label="Had the client/counterparty or UBO been previously subject to criminal proceedings of any nature?"
                    name="criminalProceedings"
                    value={formData.criminalProceedings}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    required={true}
                    options={yesNoOption}
                    isReport={isReport}
                />
                <SubHead text="Tax Risk" isReport={isReport} />
                <RadioGroup
                    label="Are there any indications that the transaction would facilitate tax evasion?"
                    name="taxInvasionIndication"
                    value={formData.taxInvasionIndication}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    options={yesNoOption}
                    required={true}
                    isReport={isReport}
                />
                <SubHead text="Delivery Channel Risk" isReport={isReport} />
                <RadioGroup
                    label="Does the transaction involve an intermediary who has the ability to influence/ control the transaction?"
                    name="InfluenceTransaction"
                    value={formData.InfluenceTransaction}
                    disabled={isReadOnly}
                    onChange={handleChange}
                    options={yesNoOption}
                    required={true}
                    isReport={isReport}
                />
                {formData.InfluenceTransaction === "Yes" && (
                    <>
                    <Input
                        label="Name of intermediary/ lead contact"
                        isReport={isReport}
                        type="text"
                        name="IntermediaryName"
                        value={formData.IntermediaryName}
                        required={true}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        style={{ marginTop: "10px", width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                    />
                    <Input
                        label="Role of Intermediary/Lead Contact"
                        isReport={isReport}
                        type="text"
                        name="IntermediaryRole"
                        value={formData.IntermediaryRole}
                        required={true}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        style={{ marginTop: "10px", width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                    />
                    </>
                )}

            </form>
<ConfirmActionModal
  visible={showAdverseSearchModal}
  message="Are you sure you want to perform an Adverse Media Search?  The Report will be emailed to you after the search is completed. It may take upto 30 minutes to complete the search."

  onConfirm={async () => {
    const success = await handleSearch(adverseSearchInfo);
    setShowAdverseSearchModal(false);
    if (success) {
      setAdverseSearchInfo("");
      setConfirmationModal(true);
    }
  }}
  onCancel={() => setShowAdverseSearchModal(false)}
>
  <div style={{ textAlign: "left", margin: "12px 0" }}>
    <label style={{ display: "block", fontSize: "13px", marginBottom: "4px" }}>
      Additional Identifying Information (optional)
    </label>
    <textarea
      value={adverseSearchInfo}
      onChange={(e) => setAdverseSearchInfo(e.target.value)}
      placeholder="e.g. date of birth, nationality, registration number, known aliases, or any other details that help narrow the search"
      rows={3}
      style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", resize: "vertical" }}
    />
  </div>
</ConfirmActionModal>
        <ConfirmationModal
            isOpen={confirmationModal}
            onClose={() => setConfirmationModal(false)}
            message={"Adverse Media Search has been successfully processed. "+ "The report will be emailed to " + userEmail + " in 30 minutes."}
        />

        <ConfirmActionModal
          visible={showUboSearchModal}
          message="Are you sure you want to perform a Adverse Media Search?  The Report will be emailed to you after the search is completed. It may take upto 30 minutes to complete the search."
          onConfirm={async () => {
            const success = await handleUboSearch(uboSearchInfo);
            setShowUboSearchModal(false);
            if (success) {
              setUboSearchInfo("");
              setUboConfirmationModal(true);
            }
          }}
          onCancel={() => setShowUboSearchModal(false)}
        >
          <div style={{ textAlign: "left", margin: "12px 0" }}>
            <label style={{ display: "block", fontSize: "13px", marginBottom: "4px" }}>
              Additional Identifying Information (optional)
            </label>
            <textarea
              value={uboSearchInfo}
              onChange={(e) => setUboSearchInfo(e.target.value)}
              placeholder="e.g. date of birth, nationality, registration number, known aliases, or any other details that help narrow the search"
              rows={3}
              style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", resize: "vertical" }}
            />
          </div>
        </ConfirmActionModal>

        <ConfirmationModal
            isOpen={uboConfirmationModal}
            onClose={() => setUboConfirmationModal(false)}
            message={"Adverse Media Search has been successfully processed. The report will be emailed to " + userEmail + " in 30 minutes."}
        />
          </div>
    );
};